import TYPES from '@/modules/shared/types';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import { HttpConnector } from '@/modules/shared/domain/connectors/http';
import { CreateBeneficiariesRepository } from '../../domain/repositories/create-beneficiaries-repository';
import { BeneficiaryEntity } from '../../domain/types/beneficiary-entity';

@Injectable()
export default class CreateBeneficiariesHttpRepository implements CreateBeneficiariesRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/on-boarding/customer-beneficiary/`;

  create(beneficiaries: Array<BeneficiaryEntity>): Promise<void> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint, 'POST', { customer_beneficiaries: beneficiaries })
        .then((response) => {
          response.json()
            .then(({ data, success, message }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(message));
              }
            });
        })
        .catch(reject);
    });
  }
}
